// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1T4bT","header":"PatientQuestionnaire_header__3GT7T","info":"PatientQuestionnaire_info__3jZw9"};